import styled, { css } from 'styled-components';
import { Layer } from '../layer/Layer.styled';
import { Icon } from '../styled-icon';
import { Label as label, PrimaryFont, Caption } from '../typographies/Typpographies.styled';
import { SizeAddiFontXxSmall, SizeAddiFontSmall } from '@addi/foundation/dist/web/sizes';
import { FontAddiWeightMedium, FontAddiFamilyPrimaryName, FontAddiFamilySecondaryName } from '@addi/foundation/dist/web/fonts';
import { ColorAddiFontDisable, ColorAddiFontHint, ColorAddiFontError, ColorAddiCompFiveBase, ColorAddiFontPrimary, ColorAddiGrayLighten3, ColorAddiBackgroundSoft, } from '@addi/foundation/dist/web/colors';
export const ArrowIcon = styled(Icon) `
    position: absolute;
    top: 1.5rem;
    right: 0;
    color: ${ColorAddiFontPrimary};
    font-size: ${SizeAddiFontXxSmall};
    z-index: 10;
    pointer-events: none;
`;
export const Label = styled(label) `
    position: relative;
    color: ${ColorAddiFontPrimary};
    transition-property: font-size;
    transition-duration: 4s;
    display: inline-flex;
    max-width: 150px;
    position: absolute;
    top: 0px;
    left: 0px;
    font-weight: normal;
    pointer-events: none;

    ${PrimaryFont} {
        line-height: 21px;
        font-size: ${SizeAddiFontXxSmall};
    }
`;
export const StyledSelect = styled.select `

    border: none;
    border-bottom: solid 1px ${({ isInvalid }) => isInvalid ? ColorAddiFontError : ColorAddiGrayLighten3};
    position: relative;
    box-sizing: border-box;
    background-color: transparent;
    width: 100%;
    height: 1.8rem;
    cursor: pointer;
    font-size: ${SizeAddiFontSmall};
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    font-family: ${FontAddiFamilySecondaryName};
    font-weight: ${FontAddiWeightMedium};
    color: ${ColorAddiFontPrimary};
    padding-right: 0.875rem;

    &::-ms-expand {
        display: none;
    }

    &:focus {
        outline: none;

        border-color: ${ColorAddiCompFiveBase};
        border-width: 1px;

        ${Label} {
            color: ${ColorAddiFontPrimary};
        }
    }

    & option:disabled {
        color: ${ColorAddiFontDisable};
    }

    ${props => props.disabled && css `
        background: ${ColorAddiBackgroundSoft};
        cursor: auto;
        pointer-events: none;
        user-select: none;
        color: ${ColorAddiFontDisable};

        & + ${Label} {
            color: ${ColorAddiFontDisable};
        }
    `}

    & + ${Label} {
        display: flex;
        justify-content: space-between;
    }
`;
export const Optionals = styled(Layer) `
    display: flex;
    justify-content: space-between;
    background: transparent;
    padding: 0;
    border: none;
    margin-top: 5px;
`;
export const Hint = styled(Caption) `
    font-family: ${FontAddiFamilyPrimaryName};
    font-size: ${SizeAddiFontXxSmall};
    line-height: 14px;
    color: ${ColorAddiFontHint};
    width: 50%;
`;
export const Opts = styled(Caption) `
    font-family: ${FontAddiFamilyPrimaryName};
    font-size: ${SizeAddiFontXxSmall};
    line-height: 14px;
    color: ${ColorAddiFontHint};
    width: 50%;
    text-align: right;
`;
export const Container = styled.div `
    padding: 1rem 0 0 0;
    background: transparent;
    width: ${props => props.width ? props.width : '220px'};
    position: relative;
    font-family: ${FontAddiFamilyPrimaryName};
    font-weight: ${FontAddiWeightMedium};
`;
//# sourceMappingURL=Select.styled.js.map